import { __assign } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { BaseAvatar } from '../base-avatar/base-avatar';
import { UserBadgeIcon } from '../../icons/icons-components/user-badge';
import { AgentStatusIndicator } from '../../primitives/status-indicator/status-indicator';
import { PartnerBadgeIcon } from '../../icons/icons-components/partner-badge';
import { Icon } from '../../primitives/icon/icon';
export var getUserInitials = function (user) {
    var firstName = user.firstName ? user.firstName : (user.fullName ? user.fullName.split(' ')[0] : '');
    var lastName = user.lastName ? user.lastName : (user.fullName ? user.fullName.split(' ')[1] : '');
    var firstLetter = '';
    var secondLetter = '';
    if (firstName) {
        firstLetter = firstName.slice(0, 1).toUpperCase();
        secondLetter = (lastName ? lastName.slice(0, 1).toUpperCase() : firstName.slice(1, 2)) || '';
    }
    return firstLetter ? (firstLetter + secondLetter) : '?';
};
var resolveBadgeSize = function (size) {
    switch (size) {
        case 'large':
        case 'xlarge':
            return 'large';
        case 'small':
        case 'xsmall':
            return 'small';
        case 'xxsmall':
            return 'xxsmall';
        case 'tiny':
            return null;
        case 'normal':
        default:
            return 'normal';
    }
};
export var UserBadge = function (props) {
    var badgeSize = resolveBadgeSize(props.size);
    if (badgeSize) {
        return React.createElement(UserBadgeIcon, { size: badgeSize });
    }
    return null;
};
export var PartnerBadge = function (props) {
    var badgeSize = resolveBadgeSize(props.size);
    if (badgeSize) {
        return React.createElement(PartnerBadgeIcon, { size: badgeSize });
    }
    return null;
};
export var UserAvatar = function (props) {
    var avatarSize = props.size ? props.size : 'normal';
    var text = getUserInitials(props.user);
    var imgSrc = props.user.profileImage || '';
    var isAnon = (text === '?') ? 'anonymous' : '';
    var className = namespacedClassnames('user-avatar', isAnon, avatarSize, props.className);
    var isAgent = (props.isAgent !== undefined) ?
        props.isAgent : (props.user.isAgent !== undefined) ?
        props.user.isAgent : false;
    var status = props.status ?
        React.createElement(AgentStatusIndicator, { active: props.isActive, status: props.status, size: avatarSize }) : null;
    var renderBadge = function () {
        if (isAgent) {
            return status;
        }
        else if (props.badgeIcon) {
            return React.createElement(Icon, { className: "badge ".concat(avatarSize), icon: props.badgeIcon });
        }
        else if (props.user.isPartner) {
            return React.createElement(PartnerBadge, { size: avatarSize });
        }
        return React.createElement(UserBadge, { size: avatarSize });
    };
    return (React.createElement("div", { className: className },
        React.createElement(BaseAvatar, { className: 'avatar-inner', size: avatarSize, id: props.user.id, initials: text, imgSrc: imgSrc }),
        renderBadge()));
};
export var UserAvatarOnBg = function (props) {
    var size = props.size || 'normal';
    var className = namespacedClassnames('avatar-on-background');
    return React.createElement(UserAvatar, __assign({ className: className }, props, { size: size }));
};
//# sourceMappingURL=user-avatar.js.map